import SignupForm from './SignupForm.container';

export default SignupForm;
